import { CmsBoolean } from './boolean';

export enum CmsBrowseResultBannerMatchType {
  Treatment = 'treatment',
  TreatmentType = 'treatment-type',
}

export interface CmsBrowseResultBanner {
  enabled: CmsBoolean;
  'image-mobile': string;
  'image-desktop': string;
  title: string;
  text: string;
  'background-colour': string;
  colour: string;
  'campaign-id': string;
  link?: string;
  'cta-text'?: string;
  'match-type'?: CmsBrowseResultBannerMatchType;
  'match-value'?: string;
}
